var map = {
	"./aachen/de.json": "4498",
	"./apoterm_de/de.json": "0c3b",
	"./bayern/de.json": "2803",
	"./de/de.json": "4c74",
	"./default.json": "369a",
	"./divacs_de/de.json": "5cfb",
	"./nrw/de.json": "31ea",
	"./nrw/en.json": "cf3c",
	"./st_vac/de.json": "bdc8",
	"./st_vac/it.json": "d751",
	"./wir_testen/de.json": "f698",
	"./wir_testen/en.json": "0972",
	"./wir_testen/it.json": "f4f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "231a";